import React from "react";
import avatar from "../../assets/avatar.png";
import logo from "../../assets/logo.png";
import { menus } from "../../utils/tools/menu";
import MenuAccordion from "./MenuAccordion";
const Sidebar = () => {
  return (
    <div className="mono_sidebar">
      <div className="mono_logo_container">
        <img src={logo} width="100%" alt="logo" />
      </div>
      <div className="mono_user_profile">
        <div className="mono_user_pic">
          <img src={avatar} alt="user_pic" />
        </div>
        <div className="mono_user_info">
          <h2>MLM POINT</h2>
          <p>support@mlmpoint.org</p>
        </div>
      </div>
      <div className="mono_sidebar_menu">
        <ul className="mono_sidebar_menu_lists">
          {menus && menus?.map((d,i) => <MenuAccordion key={i+1} d={d} />)}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
